import { fg } from '@atlaskit/platform-feature-flags/fg';

export default {
	get(): boolean {
		return fg('rovo_fps_video_include_metadata_content');
	},
};
